import React, { createContext, useState, useContext, useEffect } from "react";
import AuthContext from "./AuthContext";

const CompanyContext = createContext();

export const CompanyProvider = ({ children }) => {
  const { user } = useContext(AuthContext);

  const companies = [
    { id: 1, name: 'Careys', emailaddress: null },
    { id: 2, name: 'BVM' , emailaddress: 'admin@brisbanevalleymeats.com.au'},
    { id: 3, name: 'Millmerran Abattoir' , emailaddress: 'officemillabs@gmail.com' },
    { id: 4, name: 'Test Corp', emailaddress: 'testcorp@meatworx.com' }
  ];

  // Initialize from localStorage or default to first company
  const [selectedCompany, setSelectedCompany] = useState(() => {
    const stored = localStorage.getItem("selectedCompany");
    return stored ? parseInt(stored) : companies[0].id;
  });

  // When the logged-in user changes (login/logout/switch account),
  // reset selectedCompany to that user's own company_id.
  // This prevents a previously logged-in admin's stored company leaking
  // into a non-admin session (e.g. admin on Careys → BVM non-admin still
  //
  // IMPORTANT: only do this for non-admin users. Admins are allowed to
  // view any company via the "Viewing Company" dropdown (changeCompany),
  // and their own account's company_id is irrelevant to that choice. This
  // effect used to fire for admins too whenever `user` was re-fetched with
  // the same company_id value, silently overwriting a manually-selected
  // "Viewing Company" back to the admin's own company - which is why
  // customer creates were landing in the wrong schema after switching.
  useEffect(() => {
    if (user?.company_id && user?.role_id !== 1) {
      const userCompanyId = parseInt(user.company_id);
      console.log("👤 User changed, resetting selectedCompany to:", userCompanyId);
      setSelectedCompany(userCompanyId);
      localStorage.setItem("selectedCompany", String(userCompanyId));
    }
  }, [user?.company_id, user?.role_id]);

  const changeCompany = (companyId) => {
    const newCompanyId = parseInt(companyId);
    console.log("🔄 changeCompany called:", newCompanyId);
    setSelectedCompany(newCompanyId);
    localStorage.setItem("selectedCompany", String(newCompanyId));
  };

  // Log whenever selectedCompany changes
  useEffect(() => {
    console.log("✅ selectedCompany updated to:", selectedCompany);
    console.log("📦 localStorage selectedCompany:", localStorage.getItem("selectedCompany"));
  }, [selectedCompany]);

  return (
    <CompanyContext.Provider
      value={{
        selectedCompany,
        changeCompany,
        companies,
        isAdmin: user?.role_id === 1
      }}
    >
      {children}
    </CompanyContext.Provider>
  );
};

export const useCompany = () => {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error('useCompany must be used within CompanyProvider');
  }
  return context;
};

export default CompanyContext;